<kendo-switch [(ngModel)]="value" (ngModelChange)="valueChange.emit()"></kendo-switch>
